// extracted by mini-css-extract-plugin
export default {"TrackingLink":"TrackingInfo_TrackingLink__a+9G3"};